import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
} from '@mui/material';
import CustomButton from '../../../../../../../../lib/designSystem/Button';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../../lib/designSystem/CircularProgress';
import EnhancedTable from '../../../../../../../../lib/designSystem/Table';
import { createUsersBusinessesPortfolio } from '../../../../../../../../lib/api';
import { showAlert } from '../../../../../../../../lib/functions/utils';

const BatchPortfolio = (props: any) => {
  const {
    businessesWithNoExecutives,
    byStakeholder,
    newExecutiveOptions,
    openBatchPortfolio,
    setOpenBatchPortfolio,
    fetchData,
  } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedBusinesses, setSelectedBusinesses] = useState([]);
  const [executive, setExecutive] = useState<string | null>(null);
  const [executiveError, setExecutiveError] = useState(false);
  const [businessSelectedForFilter, setBusinessSelectedForFilter] = useState<{
    id: string;
    name: string;
  } | null>(null);

  const handleAssign = async () => {
    if (!executive) {
      setExecutiveError(true);
      return showAlert(dispatch, 'warning', 'Debes seleccionar un ejecutivo');
    }
    if (selectedBusinesses.length === 0) {
      return showAlert(
        dispatch,
        'warning',
        `Debes seleccionar al menos un ${singular}`,
      );
    }
    setLoading(true);
    try {
      await createUsersBusinessesPortfolio(dispatch, parseInt(executive), {
        businessIdentifiers: selectedBusinesses,
      });
      showAlert(dispatch, 'success', 'Asignación exitosa');
      fetchData();
      setOpenBatchPortfolio(false);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const bussinessToAssign = () => {
    if (businessSelectedForFilter) {
      return businessesWithNoExecutives.filter(
        (business: any) => business.id === businessSelectedForFilter.id,
      );
    }
    return businessesWithNoExecutives;
  };

  const singular = byStakeholder ? 'deudor' : 'cliente';
  const plural = byStakeholder ? 'deudores' : 'clientes';

  const headers = [
    {
      label: `Rut ${singular}`,
      key: 'id',
    },
    {
      label: `Razón social ${singular}`,
      key: 'name',
    },
  ];

  const filterBusinesses = () => {
    return (
      <Autocomplete
        style={{ width: '300px' }}
        options={businessesWithNoExecutives}
        value={businessSelectedForFilter}
        getOptionLabel={(option: any) => `${option.name} - (${option.id})`}
        renderInput={(params) => (
          <TextField
            style={{ minWidth: 100 }}
            {...params}
            label="Filtrar empresas"
          />
        )}
        onChange={(e, value: any) => setBusinessSelectedForFilter(value)}
        fullWidth
      />
    );
  };

  return (
    <Dialog
      open={openBatchPortfolio}
      onClose={() => setOpenBatchPortfolio(false)}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>Asignación de {plural} masiva a ejecutivos</DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ minHeight: 200 }}>
            <CenteredCircularProgress type="dialog" />
          </div>
        ) : (
          <>
            <div
              style={{
                padding: '8px 0px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ minWidth: 250 }}>
                <FormControl fullWidth>
                  <InputLabel id={`executive-label`}>
                    Ejecutivo a asignar
                  </InputLabel>
                  <Select
                    labelId={`executive-label`}
                    label="Ejecutivo a asignar"
                    id={`executive-select`}
                    fullWidth
                    error={executiveError}
                    value={executive}
                    onChange={(e) => {
                      setExecutive(e.target.value);
                      setExecutiveError(false);
                    }}
                  >
                    {newExecutiveOptions.map((option: any) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name} ({option.collectionPortfolioSize})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <div>{filterBusinesses()}</div>
            </div>
            <EnhancedTable
              data={bussinessToAssign()}
              dataHeaders={headers}
              selected={selectedBusinesses}
              setSelected={setSelectedBusinesses}
              canSelectAll
            />
          </>
        )}
        {/* Podria ocuparse eventualmente segun feedback cliente */}
        {/* <Grid container spacing={2} sx={{ paddingTop: 2 }}>
          {businessesWithNoExecutives.map((business: any) => (
            <>
              <Grid item xs={3} key={business.id}>
                <Typography>{business.identifier}</Typography>
              </Grid>
              <Grid item xs={3} key={business.id}>
                <Typography>{business.name}</Typography>
              </Grid>
              <Grid item xs={6} key={business.id}>
                <FormControl fullWidth>
                  <InputLabel id={`executive-label-${business.id}`}>
                    Ejecutivo
                  </InputLabel>
                  <Select
                    labelId={`executive-label-${business.id}`}
                    label="Ejecutivo"
                    id={`executive-select-${business.id}`}
                    fullWidth
                  >
                    {newExecutiveOptions.map((option: any) => (
                      <MenuItem key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </>
          ))}
        </Grid> */}
      </DialogContent>
      <DialogActions>
        <CustomButton
          color={'secondary'}
          onClick={() => setOpenBatchPortfolio(false)}
          disabled={loading}
        >
          Salir
        </CustomButton>
        <CustomButton
          color={'primary'}
          onClick={handleAssign}
          disabled={loading}
        >
          Asignar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default BatchPortfolio;
